module.exports = __webpack_public_path__ + "img/Owner_Warehouse.ba2894ad.webp";